import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/admin/PartnerOutreach";

export const Route = createFileRoute("/admin/parteneriate/")({
  head: () => ({
    meta: [
      { title: "Parteneriate și mențiuni | RO Auto Market" },
      { name: "description", content: "Administrare contacte editoriale și parteneri RO Auto Market." },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Parteneriate și mențiuni | RO Auto Market" },
      { property: "og:description", content: "Administrare contacte editoriale și parteneri." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: Page,
});
